/**
 * Formats a number with comma separators (e.g., 1,234,567)
 * @param {number|string} num - The number to format
 * @returns {string} The formatted number
 */
export const formatNumber = (num) => {
  if (num === null || num === undefined || isNaN(num)) return '0';
  return Number(num).toLocaleString('en-US');
};

/**
 * Formats a number as currency (e.g., $1,234,567)
 * @param {number|string} num - The number to format
 * @returns {string} The formatted currency string
 */
export const formatCurrency = (num) => {
  if (num === null || num === undefined || isNaN(num)) return '$0';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(num);
};
